export default __webpack_public_path__ + "static/media/2.6b51d8ad.jpg";